import React from "react";
import Router from "next/router";
import Head from "next/head";
import Link from "next/link";

import Cookies from "universal-cookie";
import Package from "../package";
import Styles from "../css/index.scss";
import styles from "antd/dist/antd.css";

import { Layout, Menu, Breadcrumb, Icon } from "antd";
const { Header, Content, Footer, Sider } = Layout;
const SubMenu = Menu.SubMenu;

export default class extends React.Component {
  static propTypes() {
    return {
      session: React.PropTypes.object.isRequired,
      providers: React.PropTypes.object.isRequired,
      children: React.PropTypes.object.isRequired,
      fluid: React.PropTypes.boolean,
      navmenu: React.PropTypes.boolean,
      signinBtn: React.PropTypes.boolean,
    };
  }

  constructor(props) {
    super(props);
    this.state = {
      collapsed: false,
      name: props.name,
      item: props.item,
      key: props.key,
    };
  }

  onCollapse = (collapsed) => {
    console.log(collapsed);
    this.setState({ collapsed });
  };

  getName() {
    this.setState({
      name: calendrier,
    });
  }

  selectedItem() {
    console.log(defaultSelectedKeys);
  }

  componentDidMount() {
    console.log(this.state.key);
  }

  render() {
    return (
      <React.Fragment>
        <Head>
          <meta charSet="UTF-8" />
          <meta name="viewport" content="width=device-width, initial-scale=1" />
          <title>
            Le Hub Bezannes - Plateforme dédiée aux adhérents de l'association
          </title>
          <link
            rel="icon"
            type="image/png"
            href="/static/images/Le_Hub_Bezannes_logo.png"
          />
          <style dangerouslySetInnerHTML={{ __html: styles }} />
          <script src="https://cdn.polyfill.io/v2/polyfill.min.js" />
          <link
            rel="stylesheet"
            href="//cdn.quilljs.com/1.2.6/quill.snow.css"
          />
          <script src="https://cdnjs.cloudflare.com/ajax/libs/moment.js/2.18.1/moment.min.js"></script>
        </Head>
        <style dangerouslySetInnerHTML={{ __html: Styles }} />
        {this.props.hidden ? this.props.children : null}
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./components/layoute.js